<template>
  <div class="trading-platform-container">
    <iframe style="width: 100%; height: 800px;" :src="url()"></iframe>
  </div>
</template>
<script>

</script>
<script>

export default {
  methods: {
    url() {
      if (this.tpToken) {
        return "https://demowtv4.leverate.com/?jwttoken=" + this.tpToken + "&isInIframe=true";
      }
      return "https://demowtv4.leverate.com/login";
    }
  }
}
</script>